import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { EditClientScreenContent } from './EditClientScreenContent';

export const Screen: React.FC = () => {
  const { client_id } = useParams<{ client_id: string }>();

  if (!client_id) {
    return null;
  }

  return (
    <Suspense fallback={<Loader />}>
      <EditClientScreenContent clientId={Number(client_id)} />
    </Suspense>
  );
};
